import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SuccessComponent } from './success.component';
import { SharedUiModule } from '@emi/shared/ui';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedUiModule
  ],
  declarations: [
    SuccessComponent
  ],
  exports: [
    SuccessComponent
  ],
})
export class SharedFeatureSuccessModule {}
